import React from "react";

import { defaultInitialState } from "../table/shared.js";

import * as Constants from "../../config/constants/Constants.js";

/**
 * Hook to define states related to paginated values.
 * Allows for easy state creation and logging.
 */
export const useDataGridPaginationState = (name = "Unknown", options = {}) => {
    const { logData = false, logPagination = false, pageSize: size = Constants.DEFAULT_TABLE_ROWS_PER_PAGE } = options;
    const { initialSorting, initialFilter, columnVisibility, initialState = [] } = options;

    const initialTableState = defaultInitialState({ sorting: initialSorting, filter: initialFilter, columnVisibility });

    // Data.
    const [data, setData] = React.useState(initialState);
    const [selected, setSelected] = React.useState(initialState);

    // Pagination.
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(size);

    const [filter, setFilter] = React.useState(initialTableState.filter.filterModel);
    const [sort, setSort] = React.useState(initialTableState.sorting.sortModel);
    const [visibility, setVisibility] = React.useState(initialTableState.columns.columnVisibilityModel);

    const [queriedUntil, setQueriedUntil] = React.useState(0);
    const [rowCount, setRowCount] = React.useState(0);

    const [queryLoading, setQueryLoading] = React.useState(false);

    React.useEffect(() => {
        if (!logData) return;

        console.log(`=== ${name} (DATA) ===`);
        console.log("data", JSON.parse(JSON.stringify(data)));
        console.log("selected", JSON.parse(JSON.stringify(selected)));
        console.log("\n");
    }, [data, selected]);

    React.useEffect(() => {
        if (!logPagination) return;

        console.log(`=== ${name} (PAGINATION) ===`);
        console.log("page", JSON.parse(JSON.stringify(page)));
        console.log("pageSize", JSON.parse(JSON.stringify(pageSize)));
        console.log("filter", JSON.parse(JSON.stringify(filter)));
        console.log("sort", JSON.parse(JSON.stringify(sort)));
        console.log("visibility", JSON.parse(JSON.stringify(visibility)));
        console.log("queriedUntil", JSON.parse(JSON.stringify(queriedUntil)));
        console.log("rowCount", JSON.parse(JSON.stringify(rowCount)));
        console.log("queryLoading", JSON.parse(JSON.stringify(queryLoading)));
        console.log("\n");
    }, [page, pageSize, filter, sort, visibility, queriedUntil, rowCount, queryLoading]);

    return {
        data,
        setData,
        selected,
        setSelected,

        page,
        setPage,
        pageSize,
        setPageSize,

        filter,
        setFilter,
        sort,
        setSort,
        visibility,
        setVisibility,

        queriedUntil,
        setQueriedUntil,
        rowCount,
        setRowCount,

        queryLoading,
        setQueryLoading
    };
};
